import { useState } from "react";

import { useAnalyticsTracker } from "../../../../Atoms/Analytics";
import styles from "./Itinerary.module.css";
import MTIcon from "./MTIcon";

interface Props {
  data: {
    itinerary: string;
  };
  showHeader?: boolean;
}

export default function Itinerary({
  data: { itinerary },
  showHeader = true,
}: Props) {
  const [state, setState] = useState({ collapsed: false });
  const tracker = useAnalyticsTracker();

  function toggle() {
    setState((state) => ({
      collapsed: !state.collapsed,
    }));

    tracker.trackEvent({
      category: "itinerary",
      action: state.collapsed ? "show" : "hide",
    });
  }

  const hasPlaces = itinerary && itinerary.length > 0;

  const itineraryStyle = () => {
    const items = itinerary.split("\n").length;
    if (items < 5 && items > 2) {
      return {
        height: `${100 - itinerary.split("\n").length * 2}%`,
      };
    }
    if (items === 2) {
      return { height: "90%" };
    }
    return {};
  };

  return hasPlaces ? (
    <div className={styles.DetailPartsItinerary}>
      {state.collapsed ? null : (
        <>
          {" "}
          {showHeader && <p>Itinerary</p>}
          <ul>
            <hr style={itineraryStyle()} />
            {itinerary.split("\n").map((place, index) => {
              return (
                <li key={index}>
                  <span className={styles.DetailPartsItineraryIcon}>
                    {index === 0 && <MTIcon />}
                  </span>
                  <span>{place}</span>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  ) : null;
}
